import React, { useCallback } from 'react';
import {
  setSiteViewportFullscreen,
  setSiteViewportSize,
} from '../../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { getSiteViewportFullscreen } from '../../../selectors';
import styled from 'styled-components';

const Triangle = styled.div`
  border-bottom: 10px solid rgba(0, 0, 0, 0);
  border-left: 10px solid black;
  border-right: 10px solid rgba(0, 0, 0, 0);
  border-top: 10px solid black;
  cursor: pointer;
  height: 0;
  left: 0;
  opacity: 0.07;
  position: absolute;
  top: 0;
  transition: opacity 620ms 500ms, transform 220ms;
  width: 0;
  z-index: 1;

  :hover {
    opacity: 0.8;
    transition: opacity 320ms, transform 220ms;
  }

  :active {
    opacity: 1;
    transition: opacity 20ms, transform 220ms;
  }
`;

export const AdminSiteViewportFullscreenButton: React.FunctionComponent = (): React.ReactElement => {
  const isFullscreen = useSelector(getSiteViewportFullscreen);
  const dispatch = useDispatch();

  const onClick = useCallback((): void => {
    dispatch(setSiteViewportFullscreen(!isFullscreen));
    dispatch(setSiteViewportSize('lg'));
  }, [isFullscreen]);

  return (
    <Triangle
      onClick={onClick}
      style={{
        transform: isFullscreen
          ? 'rotate3d(1,-1,0,180deg)'
          : 'rotate3d(0,0,0,180deg)',
      }}
    />
  );
};
